import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './DeleteCover.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageDeleteCoverMutationVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
}>;


export type EntityPageDeleteCoverMutation = (
  { __typename?: 'Mutation' }
  & { entityPageDeleteCover?: Types.Maybe<(
    { __typename?: 'EntityPageMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'EntityPagesMutationError' }
      & Pick<Types.EntityPagesMutationError, 'errorType' | 'errorCode'>
    )> }
  )> }
);


export type EntityPageDeleteCoverMutationFn = Apollo.MutationFunction<EntityPageDeleteCoverMutation, EntityPageDeleteCoverMutationVariables>;

/**
 * __useEntityPageDeleteCoverMutation__
 *
 * To run a mutation, you first call `useEntityPageDeleteCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageDeleteCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageDeleteCoverMutation, { data, loading, error }] = useEntityPageDeleteCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityPageDeleteCoverMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageDeleteCoverMutation, EntityPageDeleteCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageDeleteCoverMutation, EntityPageDeleteCoverMutationVariables>(Operations.EntityPageDeleteCover, options);
      }
export type EntityPageDeleteCoverMutationHookResult = ReturnType<typeof useEntityPageDeleteCoverMutation>;
export type EntityPageDeleteCoverMutationResult = Apollo.MutationResult<EntityPageDeleteCoverMutation>;
export type EntityPageDeleteCoverMutationOptions = Apollo.BaseMutationOptions<EntityPageDeleteCoverMutation, EntityPageDeleteCoverMutationVariables>;